<template>
    <div>
        <avue-crud :data="data"  ref="crud" :option="option">
            <template slot-scope="scope" slot="record_url">
                <span v-if="scope.row.duration1==0&&scope.row.duration!==0">录音文件生成中...</span>
                <audio :src="scope.row.record_url" controls
                       v-if="scope.row.duration!==0"
                       @canplay="(e) => getDuration(e, scope.row)"></audio>
            </template>
        </avue-crud>
    </div>
</template>

<script>
import { cluesCallRecord } from '@/api/callCenter';

export default {
    name: 'callLog',
    data() {
        return {
            listArgument:{
                id:this.$route.query.id,
                limit:50,
                page:1
            },
            data:[],
            duration:'',  //音频总时长
            option: {
                stripe: true,
                // index:true,
                searchMenuSpan: 3,
                indexLabel: '序号',  //添加序号
                selection: false, //批量选择
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menu: false,
                menuType: 'menu',
                menuBtnTitle: '操作',
                column: [
                    {
                        label: '通话记录ID',
                        prop: 'id'
                    },
                    {
                        label: '被叫号码',
                        prop: 'tel_b'
                    },
                    {
                        label: '通话接通时间',
                        prop: 'start'
                    },
                    {
                        label: '通话结束时间',
                        prop: 'end'
                    },
                    {
                        label: '通话时长(秒)',
                        prop: 'duration'
                    },
                    {
                        label: '录音链接',
                        prop: 'record_url',
                        width: '350'
                    },
                ]
            }
        };
    },
    methods:{
        getDuration(e, row) {
            row.duration1 = e.target.duration; // 将时长存储到当前行数据
        },
    },
    created() {
        cluesCallRecord(this.listArgument).then(res=>{
            if (res.code==200){
                this.data=res.data.list.map(item => ({
                    ...item,
                    duration1: 0 // 初始化时长字段
                }))
            }else {
                this.$message.error(res.msg)
            }
        })
    }
}
</script>

<style scoped lang="scss">
::v-deep .avue-crud__menu{
    min-height: 0px;
}
::v-deep .el-card__body{
    padding: 20px;
}
</style>